import React, { useContext, useEffect } from "react";
import DecodeYourWorkSelfImg from "../../../assets/DecodeYourWorkSelf.png";
import star from "../../../assets/stars.png";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../UserContext";

const DecodeYourWorkSelf = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

  // 🔁 Check if quiz is in progress
  useEffect(() => {
    const checkInProgressQuiz = async () => {
      const tempUserId = localStorage.getItem("temp_user_id");
      if (!tempUserId) return;

      try {
        const res = await fetch(`${apiBaseURL}/quiz/progress/${tempUserId}`);
        const data = await res.json();

        if (data?.current_page) {
          navigate("/quiz", { state: { resumed: true, userId: user } });
        }
      } catch (err) {
        console.error("Failed to check quiz progress:", err);
      }
    };

    checkInProgressQuiz();
  }, [navigate, user, apiBaseURL]);

  const handleClick = () => {
    navigate("/quiz", { state: { userId: user } });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 py-12 text-center bg-white">
      {/* Illustration */}
      <img
        src={DecodeYourWorkSelfImg}
        alt="Work Persona Illustration"
        className="w-32 h-32 md:w-[280px] md:h-[280px] mb-6"
      />

      {/* Title */}
      <h2 className="text-xl sm:text-[22px] md:text-[28px] lg:text-2xl font-bold text-[#323232] font-gotham mb-4 flex gap-1.5">
        <span>
          <img src={star} alt="" className="w-7 h-7 rotate-180 mt-0.5" />
        </span>{" "}
        Decode Your Work Self{" "}
        <span>
          <img src={star} alt="" className="w-7 h-7" />
        </span>
      </h2>

      {/* Description */}
      <p className="max-w-xl text-sm sm:text-base text-[#323232] font-gotham font-medium mb-6 px-2 sm:px-0">
        Ever wondered if you’re built for the corporate game—or just surviving
        it? This isn’t a test of skills, it’s a mirror into how you think, cope,
        compete, and stay sane in a system that’s not built for everyone. In
        just a few minutes, you’ll uncover patterns, blind spots, and maybe a
        truth or two you’ve been avoiding. Ready to see what the corporate world
        brings out in you?
      </p>

      {/* Button */}
      <button
        onClick={handleClick}
        className="bg-[#54B0AF] hover:bg-teal-600 text-white text-sm sm:text-base font-bold py-2 px-6 rounded-[80px] transition font-gotham duration-300 ease-in-out"
      >
        Discover your work persona
      </button>
    </div>
  );
};

export default DecodeYourWorkSelf;
